// extracted by mini-css-extract-plugin
module.exports = {"panel":"GettingStarted_panel__24fvV","flex":"GettingStarted_flex__2tlOU","videosContainer":"GettingStarted_videosContainer__3cUvj"};